import { createFileRoute } from "@tanstack/react-router";
import { RevealStagger } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { businessServices, stats, whatsappLink } from "@/content/site";

export const Route = createFileRoute("/empresas")({
  head: () => ({
    meta: [
      { title: "Internet para empresas — Link dedicado e telefonia | Contato" },
      {
        name: "description",
        content:
          "Link dedicado com SLA, IP fixo, telefonia IP, hospedagem e projetos corporativos. Mais de 1000 empresas conectadas pela Contato.",
      },
      { property: "og:title", content: "Internet para empresas — Contato Internet" },
      {
        property: "og:description",
        content: "Link dedicado com SLA, IP fixo, telefonia IP e hospedagem para a sua operação.",
      },
    ],
  }),
  component: EmpresasPage,
});

function EmpresasPage() {
  return (
    <>
      <Section
        reveal
        dark
        eyebrow="Contato Empresas"
        title="Mais de 1000 empresas confiam em nós"
        text="Estrutura de operadora, atendimento consultivo e uma equipe que conhece o seu negócio."
      >
        <RevealStagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" staggerDelay={100}>
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-3xl border border-brand-sky/25 bg-brand-sky/10 p-7"
            >
              <p className="text-3xl font-extrabold text-brand-yellow">{s.value}</p>
              <p className="mt-1 text-sm text-brand-sky">{s.label}</p>
            </div>
          ))}
        </RevealStagger>
      </Section>

      <Section
        reveal
        eyebrow="Soluções"
        title="Tudo o que sua operação precisa em um só fornecedor"
      >
        <RevealStagger className="grid gap-6 sm:grid-cols-2" staggerDelay={120}>
          {businessServices.map((s) => (
            <article key={s.title} className="rounded-3xl border border-border bg-card p-8">
              <h3 className="text-xl">{s.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground">{s.text}</p>
            </article>
          ))}
        </RevealStagger>
      </Section>

      <Section reveal className="bg-secondary/40" title="Vamos desenhar o seu projeto?">
        <div className="text-center">
          <a
            href={whatsappLink("Olá! Quero uma proposta de link dedicado para minha empresa.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex rounded-full bg-brand-yellow px-8 py-3.5 text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground"
          >
            Solicitar proposta
          </a>
        </div>
      </Section>
    </>
  );
}
